/* Kings Crest OEM tracking loader.
   IDs live in window.KC_TRACKING (set in each page head).
   Empty string = that platform stays off. Fill IDs, redeploy, done. */
(function () {
  var cfg = window.KC_TRACKING || {};
  var isThankYou = window.location.pathname.indexOf('thank-you') !== -1;

  /* ---- Google (GA4 + Google Ads via gtag.js) ---- */
  var gtagIds = [];
  if (cfg.ga4) gtagIds.push(cfg.ga4);
  if (cfg.awId) gtagIds.push(cfg.awId);

  if (gtagIds.length) {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtagIds[0];
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { dataLayer.push(arguments); };
    gtag('js', new Date());
    gtagIds.forEach(function (id) { gtag('config', id); });

    if (isThankYou) {
      var params = new URLSearchParams(window.location.search);
      var src = params.get('src') || 'unknown';
      if (cfg.ga4) {
        gtag('event', 'generate_lead', { lead_source: src });
      }
      if (cfg.awId && cfg.awConvLabel) {
        gtag('event', 'conversion', { send_to: cfg.awId + '/' + cfg.awConvLabel });
      }
    }
  }

  /* ---- Meta Pixel ---- */
  if (cfg.metaPixel) {
    !(function (f, b, e, v, n, t, x) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      x = b.getElementsByTagName(e)[0]; x.parentNode.insertBefore(t, x);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', cfg.metaPixel);
    fbq('track', 'PageView');
    if (isThankYou) {
      fbq('track', 'Lead');
    }
  }
})();
